<template>
  <div class="paper-detail">
    <div class="paper-info">
      <div class="header">
        <div class="left">
          <div class="head-photo">
            <img
              :src="paperDetail.memberHeadUrl"
              alt=""
              class="header-img"
              v-if="paperDetail.memberHeadUrl"
            />
            <img
              src="@/assets/images/default-header.png"
              alt=""
              class="header-img"
              v-else
            />
          </div>
          <div class="info">
            <p class="nick-name">{{ paperDetail.memberName }}</p>
            <div class="gf" v-if="paperDetail.memberId === '1'">
              <span class="gf-text">官方</span>
            </div>
          </div>
        </div>
        <p class="date">{{ getDate(paperDetail.createTime) }}</p>
      </div>
      <!-- 页面内容 -->
      <!-- 普通纸条 -->
      <div class="common-paper" v-if="paperDetail.noteType === 'P'">
        <!-- 语音纸条 -->
        <div class="audio" v-if="paperDetail.noteVideo">
          <div class="audio-box" @click="playAudio">
            <img
              src="@/assets/images/sound_play.png"
              alt=""
              class="icon-audio"
            />
            <!-- <img
              src="@/assets/images/icon_voice.gif"
              alt=""
              class="icon-audio"
            /> -->
            <p class="text-audio">{{ `${paperDetail.videoTime} "` }}</p>
            <div class="tine"></div>
          </div>
        </div>
        <div class="img-text" v-else>
          <p class="content-text">{{ paperDetail.comments }}</p>
          <div
            class="img-banner"
            v-if="paperDetail.fileList && paperDetail.fileList.length > 0"
          >
            <!-- 图片九宫格 -->
            <div
              v-for="(image, index) in paperDetail.fileList"
              :key="index"
              class="image-item"
            >
              <div class="inner">
                <img class="item-img" :src="image.path" />
              </div>
            </div>
          </div>
        </div>
        <!-- 定位 -->
        <div class="address" v-if="paperDetail.address">
          <img
            class="icon-address"
            src="../assets/images/icon_zuobiao.png"
            alt=""
          />
          <span class="text-address">{{ paperDetail.address }}</span>
        </div>
      </div>
      <!-- 问题纸条 -->
      <div class="question-paper" v-else>
        <div class="question">
          <img
            src="@/assets/images/icon_question2.png"
            alt=""
            class="ques-icon"
          />
          <p class="ques-title">{{ paperDetail.comments }}</p>
        </div>
        <div class="options">
          <div
            :class="['option', item.ifChoose && 'option-selected']"
            v-for="(item, index) in paperDetail.options"
            :key="item.id"
          >
            <div class="selection">
              <img
                src="@/assets/images/icon_select.png"
                alt=""
                class="selection-img"
                v-if="item.ifChoose"
              />
              <img
                src="@/assets/images/icon_unselect.png"
                alt=""
                class="selection-img"
                v-else
              />
            </div>
            <p class="content">
              {{ item.context }}
            </p>
          </div>
        </div>
      </div>
      <!-- 标签 -->
      <div
        :class="['tags', paperDetail.noteType === 'P' && 'tags-right']"
        v-if="paperDetail.tagsStr"
      >
        <div
          class="tag"
          v-for="(tag, index) in paperDetail.tagsStr.split('，')"
          :key="index"
        >
          <img src="@/assets/images/icon_tag.png" alt="" class="tag-icon" />
          <span class="tag-con">{{ tag }}</span>
        </div>
      </div>
      <!-- 问题纸条回答数量 -->
      <div class="join-custorm" v-if="paperDetail.noteType === 'W'">
        <img src="@/assets/images/icon_person.png" alt="" class="join-icon" />
        <p class="join-text">
          <span>{{ paperDetail.answerCount }}</span> 位玩家参与投票
        </p>
      </div>
    </div>
    <!-- 评论 -->
    <comment-list type="paper" :addParams="params" />
    <open-app />
  </div>
</template>

<script>
import { getPaperDetail } from '@/service/api'
import CommentList from '@/components/CommentList.vue'
import { getUrlParams, timeFormat } from '@/utils'
import OpenApp from '@/components/OpenApp.vue'

export default {
  components: { CommentList, OpenApp },
  data() {
    return {
      paperDetail: {},
      currentIndic: 0,
      //评论参数
      params: {
        noteId: '',
      },
    }
  },
  created() {
    this.params.noteId = getUrlParams('paperId')
  },
  mounted() {
    this._getPaperDetail()
  },
  methods: {
    onChange(index) {
      this.currentIndic = index
    },
    getDate(date) {
      return timeFormat(date)
    },
    //获取美食详情
    async _getPaperDetail() {
      // const id = '8c31858e263346bd06325b4a2535fc85'
      const id = getUrlParams('paperId')
      try {
        const res = await getPaperDetail(id)
        if (res) {
          // console.log('----物品详情---', res)
          this.paperDetail = res
        }
      } catch (error) {
        this.$toast(`${error}`)
      }
    },
    playAudio() {
      this.$toast('请前往爪玩APP查看纸条语音内容，更多精彩等你哦！')
    },
  },
}
</script>

<style lang="less" scoped>
.paper-detail {
  width: 100%;
  .paper-info {
    padding: 10px 15px;
    .header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .left {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        .head-photo {
          width: 50px;
          height: 50px;
          border-radius: 30px;
          overflow: hidden;
          .header-img {
            width: 100%;
            height: 100%;
          }
        }
        .info {
          padding-left: 10px;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          .nick-name {
            font-size: 16px;
          }
          .gf {
            width: 34px;
            height: 20px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            background-color: #1296db;
            border-radius: 20px;
            margin-left: 4px;
            .gf-text {
              font-size: 10px;
              color: #fff;
            }
          }
        }
      }
      .date {
        width: 80px;
        color: #9e9e9e;
        font-size: 14px;
        text-align: right;
      }
    }
    //普通纸条
    .common-paper {
      // padding-left: 60px;
      margin-left: 60px;
      // background-color: red;
      .audio {
        margin: 20px 0;
        .audio-box {
          width: 240px;
          height: 46px;
          background-color: #f17c25;
          border-radius: 10px;
          position: relative;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          padding: 0 15px;
          .icon-audio {
            width: 16px;
            height: 16px;
          }
          .text-audio {
            color: #fff;
            font-size: 14px;
            margin-left: 10px;
            font-weight: bold;
          }
          .tine {
            width: 20px;
            height: 20px;
            background-color: #f17c25;
            position: absolute;
            border-radius: 4px;
            left: -5px;
            transform: rotate(45deg);
          }
        }
      }
      //图文纸条
      .img-text {
        .content-text {
          margin: 10px 0;
          font-size: 16px;
          color: #515151;
        }
        .img-banner {
          margin-top: 20px;
          display: flex;
          flex-direction: 'row';
          flex-wrap: wrap;
          .image-item {
            width: 33.33%;
            padding: 2px;
            position: relative;
            .inner {
              position: relative;
              height: 100%;
              width: 100%;
              border-radius: 6px;
              padding-top: 100%;
              overflow: hidden;
              .item-img {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
              }
            }
          }
        }
      }
    }
    //
    .address {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-top: 15px;
      .icon-address {
        width: 17px;
        height: 17px;
      }
      .text-address {
        flex: 1;
        padding-left: 4px;
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #9e9e9e;
      }
    }
    //问题纸条
    .question-paper {
      margin-top: 10px;
      .question {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        .ques-icon {
          width: 30px;
          height: 30px;
        }
        .ques-title {
          font-size: 16px;
          color: #515151;
          font-weight: bold;
          margin-left: 4px;
        }
      }
      .options {
        margin-top: 20px;
        .option {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          padding: 10px;
          border: 1px solid #dedede;
          background-color: #f8f8f8;
          border-radius: 10px;
          margin-bottom: 15px;
          .selection {
            width: 40px;
            .selection-img {
              width: 24px;
              height: 24px;
            }
          }
          .content {
            flex: 1;
            font-size: 14px;
          }
        }
        .option-selected {
          border: 1px solid #f17c25 !important;
        }
      }
    }
    .tags {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 20px;
      .tag {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        background-color: #f8f8f8;
        border-radius: 20px;
        padding: 4px 10px;
        margin-right: 10px;
        .tag-icon {
          width: 20px;
          height: 20px;
        }
        .tag-con {
          font-size: 14px;
          color: #1296db;
          margin-left: 4px;
        }
      }
    }
    .tags-right {
      margin-left: 60px;
    }
    .join-custorm {
      margin-top: 30px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      .join-icon {
        width: 18px;
        height: 18px;
      }
      .join-text {
        font-size: 13px;
        margin-left: 4px;
        span {
          font-family: 'DIN_Alternate';
          font-size: 14px;
        }
      }
    }
  }
}
</style>
